import { render, staticRenderFns } from "./conversation-list-group-item.vue?vue&type=template&id=890f8fac&scoped=true"
import script from "./conversation-list-group-item.vue?vue&type=script&lang=js"
export * from "./conversation-list-group-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890f8fac",
  null
  
)

export default component.exports